<div class="emds rpn-filter-modal-container">
    <div class="modal-default modal-flex" id="rpn-modal">

        <div class="modal-header">
            <span id="view-option-header-title" translate>{{ getModalTitle() }}</span>
        </div>

        <div class="modal-body remove-padding">
            <ap-view-option-form  [actionObs]="actionType$" [formProcessType]="processFormType"
                (saved)="onSaved($event)" (isClickable)="handleClickValidation($event)"
                [fcModalItemContext]="fcModalItemContext" [customData]="selectedViewOptionData"
                [mode]="mode"
            ></ap-view-option-form>
        </div>

        <div class="modal-footer">

            <ng-container *ngIf="processFormType === 'view'">
                <button id="rpn-modal-apply" class="btn-primary btn pull-right" (click)="save()"
                    [disabled]="isButtonDisabled">
                    Apply Filter 
                </button>
            </ng-container>

            <ng-container  *ngIf="processFormType === 'edit'">
                <button id="rpn-modal-apply" class="btn-primary btn pull-right" (click)="saveAndApply()"
                 [disabled]="isButtonDisabled">
                  Save & Apply Filter
                </button>
            </ng-container>

            <ng-container *ngIf="processFormType !== 'view' && !disabledSaveButton">
                <button id="rpn-modal-apply" class="btn-primary btn pull-right" (click)="save()"
                    [disabled]="isButtonDisabled">
                    Save
                </button>
            </ng-container>

            <button id="rpn-modal-cancel" class="btn btn-secondary pull-right btn-flush-right" (click)="onCancel()">
                Cancel
            </button>
        </div>
    </div>
</div>